export const phoneNumber = {
  data () {
    return {
      isShowing: false
    }
  },
  methods: {
    phoneNumberMask (phoneNumber) {
      if (!phoneNumber) return phoneNumber
      phoneNumber = phoneNumber.replace(/[^0-9]/g, '')
      return phoneNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
    }
  }
}
